/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadQueryWorkloadName extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("WorkloadQueryWorkloadName");
    }

    getFixupPrototypeFunction() { return WorkloadQueryWorkloadName.fixupPrototype; }

    static newInstance(model: Partial<WorkloadQueryWorkloadName>): WorkloadQueryWorkloadName {
        let obj = Object.assign(new WorkloadQueryWorkloadName(), model);
        WorkloadQueryWorkloadName.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadQueryWorkloadName>): WorkloadQueryWorkloadName {
        if (!model) return null;
        return WorkloadQueryWorkloadName.newInstance(<WorkloadQueryWorkloadName> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadQueryWorkloadName) {
        if (!obj) return;

        models.WorkloadQueryWorkloadName.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadQueryWorkloadName): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WorkloadQueryWorkloadName.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Regular expression to match against Workload name.
     */
    name: string;

}
